var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNounLink = function SvgNounLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#noun-link_svg__a)",
    fill: "#355B98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.78 9.05.037 1.378 2.329-.061c.82-.022 1.566.27 2.155.83.59.558.904 1.305.942 2.108.021.82-.27 1.566-.83 2.155-.558.59-1.305.904-2.108.942l-2.329.061.036 1.378 2.33-.062a4.392 4.392 0 0 0 3.081-1.361 4.352 4.352 0 0 0 1.197-3.15 4.392 4.392 0 0 0-1.361-3.082 4.392 4.392 0 0 0-3.15-1.197l-2.329.062ZM7.609 11.521c.559-.589 1.305-.904 2.108-.941l2.33-.062-.037-1.377-2.33.061A4.392 4.392 0 0 0 6.6 10.563a4.352 4.352 0 0 0-1.197 3.15 4.392 4.392 0 0 0 1.361 3.082 4.392 4.392 0 0 0 3.15 1.197l2.329-.062-.037-1.377-2.328.061a2.963 2.963 0 0 1-2.156-.829c-.589-.559-.904-1.305-.941-2.108-.038-.804.27-1.567.829-2.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.739 14.268-.037-1.391 5.566-.147.037 1.391-5.566.147Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "noun-link_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-46.513 16.038 6.892)",
    d: "M0 0h19v19H0z"
  })))));
};
export default SvgNounLink;